import { EARNING_RULE_TYPES, LOYALTY_DEFAULTS } from './constants';

export function constructEarningRule(rule, currency = LOYALTY_DEFAULTS.CURRENCY_SYMBOL) {
  if (!rule) return '';

  switch (rule.type.toString()) {
    case EARNING_RULE_TYPES.ORDER:
      const baseText = `Earn ${rule.points} point${rule.points === 1 ? '' : 's'
        } for each order`;

      return rule.minOrderAmount > 0
        ? `${baseText} of ${currency}${rule.minOrderAmount} or more`
        : baseText;

    case EARNING_RULE_TYPES.AMOUNT:
      return `Earn ${rule.points} point${rule.points === 1 ? '' : 's'
        } for every ${currency}${rule.amount} spent`;
    case EARNING_RULE_TYPES.REFERRAL:
      return `Earn ${rule.points} point${rule.points === 1 ? '' : 's'
        } for each referral`;
    case EARNING_RULE_TYPES.SIGN_UP:
      return `Earn ${rule.points} point${rule.points === 1 ? '' : 's'
        } for signing up`;
    case EARNING_RULE_TYPES.ITEM_PURCHASED:
      return `Earn ${rule.points} point${rule.points === 1 ? '' : 's'
        } for each item purchased`;
    default:
      return '';
  }
}

export const isLightColor = (hex) => {
  const color = hex.replace('#', '');
  const bigint = parseInt(color, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 200;
};
